/*
 * @Author: your name
 * @Date: 2020-12-07 18:51:56
 * @LastEditTime: 2020-12-10 13:10:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/models/chatModel.js
 */
import chatApiList from '@/service/basic/chatApiList'
import service from '@/service/chat_api'
const myhost = myhostname
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询账户信息是否绑定
 */
export function chatHttplogin(params) {
    return new Promise((resolve, reject) => {
        service({
            url: myhost + chatApiList.chatHttplogin,
            method: 'post',
            data: params
        })
            .then(function (res) {
                resolve(res.data)
            })
            .catch(function (err) {
                reject(err)
            })
    })
}

export function getDefaultUser(params) {
    return new Promise((resolve, reject) => {
        service.get(myhost + chatApiList.getDefaultUser, {
            params
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}


// WEBPACK FOOTER //
// ./src/models/chatModel.js